import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { getSerialNumber } from '@/components/dataTable/data-table.utils';
import { useDynamicLocale } from '@/hoslog-intl';
import type { ColumnDef } from '@tanstack/react-table';
import type { AccountInformationRow } from '../types';

export const getColumns = (t: ReturnType<typeof useDynamicLocale>['t']): ColumnDef<AccountInformationRow>[] => [
  {
    id: 'sn',
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.sn')} />,
    cell: ({ row, table }) => (
      <span className="text-xs text-foreground-label">{getSerialNumber(table, row.index)}</span>
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'affiliate',
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.affiliate')} />,
    cell: ({ row }) => <span className="text-xs text-foreground-label">{row.original.affiliate}</span>,
    enableHiding: false,
  },
  {
    accessorKey: 'bankType',
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.bankType')} />,
    cell: ({ row }) => <span className="text-xs text-foreground-label">{row.original.bankType}</span>,
    enableHiding: false,
  },
  {
    accessorKey: 'bankName',
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.bankInfo')} />,
    cell: ({ row }) => (
      <div className="text-xs text-foreground-label leading-tight">
        <div>{row.original.bankName}</div>
        <div className="text-[10px] text-foreground-soft">{row.original.branchName}</div>
      </div>
    ),
    enableHiding: false,
  },
  {
    accessorKey: 'accountType',
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.accountType')} />,
    cell: ({ row }) => <span className="text-xs text-foreground-label">{row.original.accountType}</span>,
    enableHiding: false,
  },
  {
    accessorKey: 'accountNumber',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title={t('common.page.tableColumn.accountNumber')} />
    ),
    cell: ({ row }) => <span className="text-xs text-foreground-label">{row.original.accountNumber}</span>,
    enableHiding: false,
  },
  {
    accessorKey: 'accountHolderName',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title={t('common.page.tableColumn.accountHolderName')} />
    ),
    cell: ({ row }) => <span className="text-xs text-foreground-label">{row.original.accountHolderName}</span>,
    enableHiding: false,
  },
  {
    id: 'createdDate',
    accessorKey: 'createdDate',
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.createdDate')} />,
    cell: () => null,
    enableHiding: false,
    enableColumnFilter: true,
  },
];
